import React, { useContext, useCallback } from 'react';
import styled from 'styled-components';

import { AppContext } from '@prisjakt/ui-app-context';
import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';

import {
  TagButton,
  ButtonText,
  ButtonIcon,
} from '@prisjakt/ui/button/variants';
import { IconClose } from '@prisjakt/ui/icon';
import { Behavior } from '@prisjakt/ui/text';

import { SearchFacetType } from 'src/areas/search/components/results/types';
import { AppliedFilter as AppliedFilterType } from '../applied-filters/types';

type Props = {
  filter: AppliedFilterType;
  onClearFilter: (filterId: string, filterType: SearchFacetType) => void;
};

export const formatFilterValue = (
  filter: AppliedFilterType,
  t: TranslateFunc
): string => {
  switch (filter.type) {
    case SearchFacetType.SEARCH_FACET_LIST: {
      const values = filter.values.map((value, index) =>
        value === '' ? filter.filterId || '?' : value
      );
      return values.length > 3
        ? `${values.slice(0, 2).join(', ')}, +${values.length - 2}`
        : values.join(', ');
    }
    default:
      return '';
  }
};

const AppliedFilter = ({ filter, onClearFilter }: Props) => {
  const { t } = useContext(AppContext);

  const clearFilter = useCallback(() => {
    onClearFilter(filter.filterId, filter.type);
  }, [filter, onClearFilter]);

  const formattedValue = formatFilterValue(filter, t);

  return (
    <AppliedFilterButton
      onClick={clearFilter}
      containerProps={{ 'data-test': 'AppliedFilter' }}
      style={{}}
    >
      <ButtonText behavior={Behavior.OnelineEllipsis}>
        {filter.title
          ? t('filter', 'applied-filter.filter-with-name', {
              name: filter.title,
              value: formattedValue,
            })
          : formattedValue}
      </ButtonText>
      <ButtonIcon>
        <IconClose />
      </ButtonIcon>
    </AppliedFilterButton>
  );
};

const AppliedFilterButton = styled(TagButton)`
  min-width: 0;
`;

export default AppliedFilter;
